import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import {
  BroadcastContactStatistics,
  BroadcastDetailHeader,
} from 'pages/broadcasts/ui/BroadcastDetail'
import { RecurringTable } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring/ui/RecurringTable/RecurringTable'
import { useBroadcastDetailRecurringContext } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailRecurring/context/context'

export const Content = observer(() => {
  const store = useBroadcastDetailRecurringContext()
  return (
    <FullPageWrapper>
      <BroadcastDetailHeader store={store} />
      <BroadcastContactStatistics filters={store.filters} />
      <RecurringTable />
    </FullPageWrapper>
  )
})
